export enum Selection {
    Company = 'company',
    Reseller = 'reseller',
    Location = 'location',
    Employee = 'employee',
    System = 'system',
}
